/**
 * @module Header
 */

"use client";

// import Link from "next/link";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import Logo from "@components/header/Logo";
import Greating from "@components/header/Greating";
import LogoutButton from "@components/header/LogoutButton";
import Menu from "@components/mobile/Menu";
import { useSelector } from "react-redux"; 
import { selectIsAuthenticated } from "@store/selectors/auth.selectors";
import { useStyleSchema } from "@components/styleSchema/StyleSchemaHandler";

/**
 * Props for the Header component
 * @public
 */
export interface HeaderType {
  /** Optional title to display in the header */
  title?: string;
  /** Optional child elements to render in the header */
  children?: ReactNode;
  /** Optional CSS class names to apply to the header */
  className?: string;
}

/**
 * Header component for the application
 * @remarks Displays the current page title and optional children elements
 */
export default function Header() {
  const { t } = useTranslation();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const { currentSchema } = useStyleSchema();
  const headerBackground = currentSchema?.backgrounds?.header;

  return (
    <header
      className={clsx(
        "header-area w-full"
      )}
    >
      <div 
        className="md:container mx-auto flex items-center justify-between gap-2 md:mt-2 p-4 md:rounded-t-3xl"
        style={{ background: headerBackground || 'transparent' }}
      >
        <div className="flex flex-col items-end">
          <Logo />
          <h2 className="text-2xl bg-gradient-to-r from-amber-300 via-yellow-500 to-amber-600 text-transparent bg-clip-text">{t("app.bonuscard")}</h2>
        </div>
        <div className="flex items-center">
          {isAuthenticated && (
            <>
              {/* Mobile menu - shown on small screens */}
              <div className="flex items-center gap-1 sm:hidden">
                <Menu />
              </div>
              
              {/* Desktop view - hidden on small screens */}
              <div className="hidden sm:flex sm:items-center gap-2">
                <Greating />
                <div className="flex items-center gap-1">
                  <LogoutButton />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
